import React, { useEffect, useState } from 'react';
import Section from '../common/Section/Section';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'primereact/dropdown';
import { ComparisonDetailMembersDataType, VotingCardDataType } from '../../types';
import { TabPanel, TabView } from 'primereact/tabview';
import DataCards from '../dataCards/DataCards/DataCards';
import { useParams } from 'react-router-dom';
import { VotingDataCard } from '../dataCards/dataCardsTemplates/VotingDataCard';
import { ComparisonVotingDataType } from '../../types/ComparisonDetailMembersDataType';
import './VotingComparison.css';

const transformDataToVotingDataType = (data: ComparisonVotingDataType[]) => {
    return data.map((item) => {
        return {
            voteId: item.id_hlasovani,
            voteNumber: Number(item.cislo_hlasovani),
            meetingNumber: item.cislo_zasedani,
            voteDescription: item.predmet_hlasovani,
            voteResult: item.vysledek === 'přijato' ? true : false,
            secret: false,
            valid: true,
            procedural: false
        };
    });
};

type Props = {
    comparison: ComparisonDetailMembersDataType['comparison'];
};

const VotingComparison = ({ comparison }: Props) => {
    const { t } = useTranslation(['analyses', 'translation']);
    const firstSession = comparison?.zasedani[0] ?? null;
    const [selectedSession, setSelectedSession] = useState(firstSession);
    const { municipalitaId, bodyType, zastupitelstvoId } = useParams();

    useEffect(() => {
        setSelectedSession(firstSession);
    }, [firstSession]);

    const sessionDropdown = (
        <div className='dropdown'>
            <h6>{t('select-meeting', { ns: 'translation' })}</h6>
            <Dropdown
                inputId='compareSessionSelection'
                value={selectedSession}
                options={comparison?.zasedani}
                onChange={(e) => setSelectedSession(e.value)}
                optionLabel='name'
            />
        </div>
    );

    const agreementData = selectedSession?.name
        ? transformDataToVotingDataType(comparison?.data[selectedSession.name]?.['shoda'] ?? [])
        : [];
    const disagreementData = selectedSession?.name
        ? transformDataToVotingDataType(comparison?.data[selectedSession.name]?.['neshoda'] ?? [])
        : [];

    const commonDataCardsProps = {
        renderCardCallback: (cardData: VotingCardDataType) => <VotingDataCard data={cardData} />,
        getCardUrl: (item: VotingCardDataType) =>
            `/${municipalitaId}/${bodyType}/${zastupitelstvoId}/hlasovani/${item.voteId}`,
        getUniqueId: (item: VotingCardDataType) => item.voteId
    };
    return (
        <Section
            title={t('comparison-councillors-votings')}
            titleElement={sessionDropdown}
            className='voting-comparison-section'
        >
            <TabView>
                <TabPanel header={t('councillors-agreement')}>
                    {agreementData.length === 0 ? (
                        t('no-votings-found')
                    ) : (
                        <DataCards {...commonDataCardsProps} cardsData={agreementData} />
                    )}
                </TabPanel>
                <TabPanel header={t('councillors-disagreement')}>
                    {disagreementData.length === 0 ? (
                        t('no-votings-found')
                    ) : (
                        <DataCards {...commonDataCardsProps} cardsData={disagreementData} />
                    )}
                </TabPanel>
            </TabView>
        </Section>
    );
};

export default VotingComparison;
